import React, { useEffect, useContext } from 'react';
import parse from 'html-react-parser';
import classNames from 'classnames';
import Hero from '../../Hero';
import ProductListing from '../../ProductListing';
import useVisibleProducts from '../../../hooks/useVisibleProducts';
import useElevarEvent from '../../../hooks/useElevarEvent';
import { convertToElevarDataItem } from '../../../utils';
import { AuthContext } from '../../../context/auth-context';

const ns = `version-legacy-plp`;

const VersionDefault = ({
	category,
	location,
	productsVisible,
	promoCard,
	campaignCopy,
}) => {
	const rootClassnames = classNames({
		[`${ns}`]: true,
	});
	const {
		products,
		image,
		title,
		descriptionHtml,
		// #########################
    // # Collection METAFIELDS #
    // #########################
		collectionIconSvg,
		heroTitle,
		heroDescription,
		heroBullets,
		heroEnableWave,
		heroFontIsDark,
		heroImageSourceUrlMobile,
		heroImageSourceUrlTablet,
		heroImageSourceUrlDesktop,
		productListingTitle,
		activeCampaign,
	} = category;

	const heroDetails = {
		title: heroTitle?.value,
		description: heroDescription?.value,
		image: {
			altText: image?.altText || 'Category Image',
			title: null,
			sourceUrl: image?.originalSrc,
			mainImageMobile: { sourceUrl: heroImageSourceUrlMobile?.value },
			tabletImage: { sourceUrl: heroImageSourceUrlTablet?.value },
			desktopImage: { sourceUrl: heroImageSourceUrlDesktop?.value },
		},
	};

	const initialProductListAmount = productsVisible?.initialAmount || 20;
	const nextProductsVisibleAmount = productsVisible?.nextAmount || 20;

	const { state: authState } = useContext(AuthContext);
	const { userProperties } = authState;

	const {
		impressions,
		handleLoadMore,
  } = useVisibleProducts(products, location, initialProductListAmount);

	const initialProducts = products.map((product, index) => convertToElevarDataItem({ item: product, index, location }));
	const initialDisplayedProducts = initialProducts.slice(0, initialProductListAmount);
	const allImpressions = [ ...initialDisplayedProducts, ...impressions ];

	useElevarEvent({
		location,
		productLength: initialProducts.length,
		eventType: 'dl_view_item_list',
		allImpressions,
		impressions,
		userProperties
	});

	return (
		<div className={rootClassnames}>
			<Hero
				pageType="category"
				heroTitle={title}
				heroDescription={descriptionHtml}
				bullets={heroBullets ? JSON.parse(heroBullets.value) : null}
				heroEnableWave={heroEnableWave?.value}
				heroFontIsDark={heroFontIsDark}
				heroDetails={heroDetails}
				icon={collectionIconSvg?.value}
			/>
			<ProductListing
				title={productListingTitle?.value}
				description={parse(descriptionHtml)}
				location={location}
				category={category}
				productsVisible={productsVisible}
				products={products}
				promo={promoCard}
				activeCampaign={activeCampaign}
				campaignCopy={campaignCopy}
				initialVisibleAmount={initialProductListAmount}
				nextVisibleAmount={nextProductsVisibleAmount}
				onLoadMore={handleLoadMore}
			/>
		</div>
	);
};

export default VersionDefault;
